import { DCBaseKeyEvent } from "./DCBaseKeyEvent.js";
export class DCKeyDownEvent extends DCBaseKeyEvent {
    eventType = "keyboard-up";
    inputType = "keyboard";
    constructor() {
        super();
    }
}
